// 报告
export default [{ // 报告列表
  path: '/reportList',
  name: 'reportList',
  component: resolve => require(['@/views/report/reportList.vue'], resolve),
  meta: {
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 查看个人报告
  path: '/reportView',
  name: 'reportView',
  component: resolve => require(['@/views/report/reportView.vue'], resolve),
  meta: {
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 查看个人报告
  path: '/:id/reportDigiman',
  name: 'reportDigiman',
  component: resolve => require(['@/views/report/reportDigiman.vue'], resolve),
  meta: {
    isLoginAuthority: true // 需要登录权限才能访问
  }
}]


// WEBPACK FOOTER //
// ./src/router/report/report.js